// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:29
import { KeywordSearchObject_abstract } from './../../abstract/SagaBase/Objects/KeywordSearchObject_abstract';
export class KeywordSearchObject extends KeywordSearchObject_abstract {}
